import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.esm.js';
import React__default from 'react';
import classNames from 'classnames';

var SpinnerCircle = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? 'primary' : _b, _c = _a.size, size = _c === void 0 ? 'large' : _c, disabled = _a.disabled, props = __rest(_a, ["theme", "size", "disabled"]);
    return (React__default.createElement("span", __assign({ className: classNames('nv-spinner-circle', {
            'nv-spinner-circle--dark': theme === 'dark',
            'nv-spinner-circle--disabled': disabled,
            'nv-spinner-circle--light': theme === 'light',
            'nv-spinner-circle--medium': size === 'medium',
            'nv-spinner-circle--secondary': theme === 'secondary',
            'nv-spinner-circle--secondaryLight': theme === 'secondary-light',
            'nv-spinner-circle--small': size === 'small',
        }) }, props)));
};

export { SpinnerCircle as default };
//# sourceMappingURL=SpinnerCircle.esm.js.map
